"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedbackList = getFeedbackList;
exports.handleFeedbackApi = handleFeedbackApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 查询意见反馈列表
function getFeedbackList(query) {
  return (0, _request.default)({
    url: 'admin/platform/feedback/list',
    method: 'post',
    data: query
  });
}

/**
 * @description 标记处理
 */
function handleFeedbackApi(data) {
  return (0, _request.default)({
    url: "admin/platform/feedback/updateStatus/".concat(data.id),
    method: 'POST',
    data: data
  });
}